<template>
  <el-dialog :title="title" :visible="visible" width="540px" :before-close="handleClose">
    <div class="modifies_dialog">
      <el-form :model="form" ref="form" :rules="rules" label-width="154px">
        <template>
          <el-form-item  prop="oldPassword">
            <template slot="label">
              <div class="form-item-label">
                <span>原密码</span>
                <span>Original password</span>
              </div>
            </template>
            <el-input v-model="form.oldPassword" :maxlength="100" placeholder="请填写原密码 Please fill in the original password"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <template slot="label">
              <div class="form-item-label">
                <span>设置新密码</span>
                <span>Set new password</span>
              </div>
            </template>
            <el-input v-model="form.password" :maxlength="100" placeholder="请填写新密码 Please fill in a new password"></el-input>
          </el-form-item>
          <el-form-item prop="rePassword">
            <template slot="label">
              <div class="form-item-label">
                <span>确认新密码</span>
                <span>Confirm new password</span>
              </div>
            </template>
            <el-input v-model="form.rePassword" :maxlength="100" placeholder="请确认新密码 Please confirm new password"></el-input>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="conserves">保 存 Save</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules: {
        oldPassword: [{ required: true, message: "请填写原密码", trigger: "blur" }],
        password: [{ required: true, message: "请填写新密码", trigger: "blur" }],
        rePassword: [{ required: true, message: "请确认新密码", trigger: "blur" }],
      },
      form: {
        oldPassword: "",
        password: "",
        rePassword: "",
      },
    };
  },
  computed: {},
  created() {},
  async mounted() {},
  methods: {
    handleClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    async conserves() {
      if (this.form.oldPassword == "" || this.form.password == "" || this.form.rePassword == "") return false;
      this.$emit("dialogCallbackModifies", this.form);
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.form-item-label{
  position: relative;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  align-items: flex-end;
  span{
    line-height: 1.2rem;
  }
}
</style>
